import React, { useState } from 'react';

const PercentageChangeCalculator = () => {
  const [value1, setValue1] = useState('');
  const [option, setOption] = useState('increase');
  const [value2, setValue2] = useState('');
  const [result, setResult] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');

  const handleCalculate = () => {
    if (!value1 || !value2) {
      setError('يرجى ادخال القيمتين بشكل صحيح');
      setResult('');
      setExplanation('');
      return;
    }
    const val1 = parseFloat(value1);
    const percent = parseFloat(value2);
    let calculatedValue = 0;
    let calculationSteps = `${val1} ${option === 'increase' ? 'إزداد' : 'نقص'} ب ${value2}% = ${val1} ${option === 'increase' ? '+' : '-'} (${val1} × ${value2}%) = ${val1} ${option === 'increase' ? '+' : '-'} (${val1} × ${percent}) = `;
    if (option === 'increase') {
      calculatedValue = val1 + (val1 * percent) / 100;
    } else {
      calculatedValue = val1 - (val1 * percent) / 100;
    }
    setResult(calculatedValue.toFixed(2));
    setExplanation(calculationSteps + calculatedValue.toFixed(2));
    setError('');
  };

  return (
    <div dir="rtl">
      <style>{`
        .inputs-row {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 6px;
        }
        .inputs-group {
          display: flex;
          align-items: center;
          gap: 6px;
          flex: 1;
        }
        .calc-btn {
          font-size: 20px;
          white-space: nowrap;
        }
        @media (max-width: 767px) {
          .calc-btn {
            width: 100%;
            text-align: center;
          }
          .inputs-group {
            width: 100%;
          }
        }
      `}</style>

      <u><h2 style={{ fontSize: '16px' }}>حاسبة تغير النسبة المئوية</h2></u><br />

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <label htmlFor="value1">القيمة:</label>
        <input
          type="number"
          placeholder="القيمة"
          value={value1}
          id="value1"
          onChange={(e) => setValue1(e.target.value)}
          className="form-control"
          style={{ width: '100px', marginRight: '5px' }}
        />
      </div>

      <div className="inputs-row">
        <div className="inputs-group">
          <label htmlFor="option">التغيير:</label>
          <select
            id="option"
            className="form-select"
            value={option}
            onChange={(e) => setOption(e.target.value)}
            style={{ flex: 1 }}
          >
            <option value="increase">زيادة</option>
            <option value="decrease">نقصان</option>
          </select>
          <input
            type="number"
            placeholder="النسبة"
            value={value2}
            onChange={(e) => setValue2(e.target.value)}
            className="form-control"
            style={{ flex: 1 }}
          />
          <span>%</span>
        </div>

        <button
          className="btn btn-success"
          onClick={handleCalculate}
        >
          إحسب
        </button>
      </div>

      <br />
      <div>
        {error !== '' ? (
          <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
        ) : (
          <>
            {result !== '' && (
              <>
                <p className="p-3 mb-2 bg-success text-white">
                  النتيجة: {value1} {option === 'increase' ? 'زيادة' : 'نقصان'} {value2}% = {result}
                </p>
                {explanation !== '' && (
                  <p className="p-3 mb-2 bg-info text-black">
                    خطوات الحل: <br />{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PercentageChangeCalculator;